import prepareComponent from "@bluframe/grapple/prepareComponent"
import {
  NewsServiceName,
  NewsSourceOverrides
} from "@bluframe/mightychroma-mightytool-frontend-types"
import { ChangeEventHandler, useCallback, useState } from "react"

import PodSource from "./PodSource"

export interface Props {
  areNewsLoading: boolean
  isCompact: boolean
  isCreated: boolean
  isLoading: boolean
  isValid: boolean
  label: string

  onClear: (serviceName: NewsServiceName) => () => void
  onSetOverrides: (
    serviceName: NewsServiceName
  ) => (overrides: NewsSourceOverrides) => void
  overrides?: NewsSourceOverrides
  serviceName: NewsServiceName
  text: string
}

export interface ComponentProps extends Omit<
  Props,
  "onClear" | "onSetOverrides"
> {
  onNameChange: ChangeEventHandler<HTMLInputElement>
  onTextChange: ChangeEventHandler<HTMLTextAreaElement>
  onCancel: () => void
  onClear: () => void
  onSave: () => void
  overrides: NewsSourceOverrides
}

const DEFAULT_OVERRIDES: NewsSourceOverrides = {}

const usePrepareComponent = ({
  onClear: onClearProps,
  onSetOverrides,
  serviceName,
  ...props
}: Props): ComponentProps => {
  const [newOverrides, setNewOverrides] = useState<NewsSourceOverrides>(
    () => props.overrides ?? DEFAULT_OVERRIDES
  )

  const onCancel = () => {
    setNewOverrides(props.overrides ?? DEFAULT_OVERRIDES)
  }

  const onSave = () => {
    onSetOverrides(serviceName)(newOverrides)
  }

  const onNameChange: ComponentProps["onNameChange"] = useCallback((event) => {
    const { value } = event.currentTarget
    setNewOverrides((prev) => ({ ...prev, name: value }))
  }, [])

  const onTextChange: ComponentProps["onTextChange"] = useCallback((event) => {
    const { value } = event.currentTarget
    setNewOverrides((prev) => ({ ...prev, text: value }))
  }, [])

  const onClear = useCallback(() => {
    const onClearServiceName = onClearProps(serviceName)

    onClearServiceName()
  }, [onClearProps, serviceName])

  return {
    ...props,
    onCancel,
    onClear,
    onNameChange,
    onSave,
    onTextChange,
    overrides: newOverrides,
    serviceName
  }
}

export default prepareComponent(usePrepareComponent)(PodSource)
